module.exports = __webpack_public_path__ + "static/img/zj1.8ca6eb3a.png";